import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setMobileOpen(prev => !prev);
  };

  const goHome = () => {
    navigate('/');
    setMobileOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-white/80 backdrop-blur-md">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">

        {/* Logo */}
        <div
          className="flex items-center cursor-pointer group"
          onClick={goHome}
        >
          <div className="flex-shrink-0 flex items-center gap-2">
            <div className="group-hover:rotate-12 transition-transform duration-300">
              <img className="max-h-12" src="https://acetn.org/images/acetn_logo.png" alt="ACE TN" />
            </div>

            <div className="flex flex-col">
              <span className="text-2xl font-black text-gray-800 leading-none tracking-tight">
                ACE TN <span className="text-pink-500">LIBRARY</span>
              </span>
              <span className="text-[10px] font-bold text-primary tracking-widest uppercase">
                Anime Club of East Tennessee
              </span>
            </div>
          </div>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          
          <a href="/#mission" className="text-sm font-medium hover:text-primary transition-colors">
            Mission
          </a>

          <Link to="/library" className="text-sm font-medium hover:text-primary transition-colors flex items-center gap-1">
            Digital Library
            <span className="bg-accent text-[10px] px-1.5 py-0.5 rounded-full text-accent-foreground font-bold"> Preview </span>
          </Link>

          <a href="/Services" className="text-sm font-medium hover:text-primary transition-colors">Community Services</a>

          {/* <Link to="/donate">
            <button className="font-bold shadow-lg hover:translate-y-[-2px] transition-all bg-accent text-accent-foreground hover:bg-accent/90 px-4 py-2 rounded-lg">
              DONATE NOW
            </button>
          </Link> */}


        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 text-foreground text-2xl"
          onClick={toggleMobileMenu}
        >
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden absolute top-16 left-0 w-full bg-white border-b shadow-lg z-40">
          <div className="flex flex-col p-4 gap-4">
            <a href="/#mission" className="text-lg font-medium" onClick={() => setMobileOpen(false)}>Mission</a>

            <Link to="/library" className="text-lg font-medium flex items-center gap-2" onClick={() => setMobileOpen(false)}>Digital Library
              <span className="bg-accent text-xs px-2 py-0.5 rounded-full text-accent-foreground font-bold">
                NEW
              </span>
            </Link>

            <Link to="/services" className="text-lg font-medium" onClick={() => setMobileOpen(false)}>
              Community Services
            </Link>

            {/* <Link to="/donate" onClick={() => setMobileOpen(false)}>
              <button className="w-full font-bold bg-accent text-accent-foreground px-4 py-3 rounded-lg">
                DONATE NOW
              </button>
            </Link> */}

          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;